import { useEffect } from "react";
import { bootstrapPixel, trackVisit } from "../lib/tracking";

// Bootstraps Meta Pixel and UTM/visit tracking on storefront mount.
export default function StorefrontBootstrap() {
  useEffect(() => {
    bootstrapPixel();
    trackVisit();
  }, []);
  return null;
}
